import React, { useState, useEffect, useRef } from "react";
import { useLocation, Link } from "react-router-dom";
import Sidebarlogo from '../assests/sidebarLogo.png';
import Usr from '../assests/user.png';
import Logo1 from '../assests/logo1.svg';
import Logo2 from '../assests/logo2.svg';
import Logo3 from '../assests/logo3.svg';
import Logo4 from '../assests/logo4.svg';
import Logo5 from '../assests/logo5.svg';
import Logo6 from '../assests/logo6.svg';
import Logo8 from '../assests/logo8.svg';
import Logo7 from '../assests/logo7.svg';
import Logo9 from '../assests/logo9.svg';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import "./SideBar.css";
import { useSelector } from "react-redux";

function SideBar({ openSidebarToggle, OpenSidebar, isMdOrAbove, onActiveLinkChange }) {
  const user = useSelector((state) => state?.user?.user);
  const permissions = user?.permissions || {}; 
  const location = useLocation();
  const currentPath = location.pathname;

  const [activeLink, setActiveLink] = useState("");
  const sidebarRef = useRef();

  useEffect(() => {
    // Update active link based on the current path
    const path = location.pathname.split("/").filter((lik) => lik)[0];
    setActiveLink(path);
    onActiveLinkChange(path);
  }, [location, onActiveLinkChange]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest("#navbar-toggle")
      ) {
        OpenSidebar(false); 
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [OpenSidebar]);

  const handleLinkClick = (section) => {
    // console.log(`Navigating to ${section}`);
    OpenSidebar(false); 
  };

  const isActive = (section) => currentPath.startsWith(section);

  // Check if the user has permission for the section based on role
  // const hasPermission = (permission) => {
  //   if (user?.role === 3) {
  //     // Super admin (role 3) has access to all sections
  //   //     if (permission === "helpAndSupport") {
  //   //   return false; 
  //   // }
  //     return true; 
  //   }
  //   //  permission for sub-admin (role 4)
  //   return permissions[permission] === true; 
  // };

  const hasPermission = (permission) => {
    if (user?.role === 3) return true;
    return permissions[permission] !== false; 
  };
  

  return (
    <>
      <aside
        ref={sidebarRef}
        id="sidebar"
        className={`sidebar-responsive ${!isMdOrAbove && !openSidebarToggle ? "d-none" : ""}`}
      >
        <div className="sidebar-title">
          <div className="sidebar-brand">
            <div className="text-center Broom-container">
              <div className="reyleaf-img">
                <img src={Sidebarlogo} alt="sidebar-logo" style={{ width: '120px', height: '150px' }} />
              </div>
            </div>
          </div>
        </div>
        <div className="sidebar-list">
          {hasPermission('dashboard') && (
            <div className={`sidebar-list-item ${isActive('/dashboard') ? 'active' : ''} sidebar-list-dash`}>
              <Link to="/dashboard" className="anch-icon" onClick={() => handleLinkClick("dashboard")}>
                <div className="icon-txt-combine">
                  <span className="dash-icon">
                    <img
                      src={Logo8}
                      alt="dashboard-icon"
                      className={`icon ${isActive('/dashboard') ? 'active' : ''}`}
                    />
                  </span>
                  &nbsp;
                  <span className="dash-text">Dashboard</span>
                </div>
              </Link>
            </div>
          )}

          {hasPermission('userManagement') && (
            <div className={`sidebar-list-item ${isActive('/user-management') ? 'active' : ''} sidebar-list-user`}>
              <Link to="/user-management" className="anch-icon" onClick={() => handleLinkClick("user-management")}>
                <div className="icon-txt-combine">
                  <span className="user-icon"><img src={Logo1} alt="user-management-icon" /></span>
                  &nbsp;
                  <span className="user-text">User Management</span>
                </div>
              </Link>
            </div>
          )}

          {hasPermission('vendorManagement') && (
            <div className={`sidebar-list-item ${isActive('/vender-management') ? 'active' : ''} sidebar-list-vendor`}>
              <Link to="/vender-management" className="anch-icon" onClick={() => handleLinkClick("vender-management")}>
                <div className="icon-txt-combine">
                  <span className="vendor-icon"><img src={Usr} alt="vendor-management-icon" /></span>
                  &nbsp;
                  <span className="vendor-text">Vender Management</span>
                </div>
              </Link>
            </div>
          )}

          {hasPermission('orders') && (
            <div className={`sidebar-list-item ${isActive('/all-order') ? 'active' : ''} sidebar-list-orders`}>
              <Link to="/all-order" className="anch-icon" onClick={() => handleLinkClick("all-order")}>
                <div className="icon-txt-combine">
                  <span className="orders-icon"><img src={Logo2} alt="orders-icon" /></span>
                  &nbsp;
                  <span className="orders-text">Orders</span>
                </div>
              </Link>
            </div>
          )}

          {hasPermission('contentModeration') && (
            <div className={`sidebar-list-item ${isActive('/content-moderation') ? 'active' : ''} sidebar-list-content-moderation`}>
              <Link to="/content-moderation" className="anch-icon" onClick={() => handleLinkClick("content-moderation")}>
                <div className="icon-txt-combine">
                  <span className="content-moderation-icon"><img src={Logo3} alt="content-moderation-icon" /></span>
                  &nbsp;
                  <span className="content-moderation-text">Content Moderation</span>
                </div>
              </Link>
            </div>
          )}

          {hasPermission('reportAndAnalysis') && (
            <div className={`sidebar-list-item ${isActive('/report-analysis') ? 'active' : ''} sidebar-list-report-analysis`}>
              <Link to="/report-analysis" className="anch-icon" onClick={() => handleLinkClick("report-analysis")}>
                <div className="icon-txt-combine">
                  <span className="report-analysis-icon"><img src={Logo4} alt="report-analysis-icon" /></span>
                  &nbsp;
                  <span className="report-analysis-text">Report & Analysis</span>
                </div>
              </Link>
            </div>
          )}

          {hasPermission('eventManagement') && (
            <div className={`sidebar-list-item ${isActive('/event-management') ? 'active' : ''} sidebar-list-event-management`}>
              <Link to="/event-management" className="anch-icon" onClick={() => handleLinkClick("event-management")}>
                <div className="icon-txt-combine">
                  <span className="event-management-icon"><img src={Logo5} alt="event-management-icon" /></span>
                  &nbsp;
                  <span className="event-management-text">Event Management</span>
                </div>
              </Link>
            </div>
          )}

          {hasPermission('pushNotification') && (
            <div className={`sidebar-list-item ${isActive('/push-notification') ? 'active' : ''} sidebar-list-push-notification`}>
              <Link to="/push-notification" className="anch-icon" onClick={() => handleLinkClick("push-notification")}>
                <div className="icon-txt-combine">
                  <span className="push-notification-icon"><img src={Logo9} alt="push-notification-icon" /></span>
                  &nbsp;
                  <span className="push-notification-text">Push Notification</span>
                </div>
              </Link>
            </div>
          )}

          {hasPermission('helpAndSupport') && (
            <div className={`sidebar-list-item ${isActive('/help-support') ? 'active' : ''} sidebar-list-help-support`}>
              <Link to="/help-support" className="anch-icon" onClick={() => handleLinkClick("help-support")}>
                <div className="icon-txt-combine">
                  <span className="help-support-icon"><img src={Logo6} alt="help-support-icon" /></span>
                  &nbsp;
                  <span className="help-support-text">Help & Support</span>
                </div>
              </Link>
            </div>
          )}

          {hasPermission('feedbacks') && (
            <div className={`sidebar-list-item ${isActive('/feedbacks') ? 'active' : ''} sidebar-list-feedbacks`}>
              <Link to="/feedbacks" className="anch-icon" onClick={() => handleLinkClick("feedbacks")}>
                <div className="icon-txt-combine">
                  <span className="feedbacks-icon"><img src={Logo7} alt="feedbacks-icon" /></span>
                  &nbsp;
                  <span className="feedbacks-text">Feedbacks</span>
                </div>
              </Link>
            </div>
          )}
        </div>
      </aside>
    </>
  );
}

export default SideBar;
